import { memo } from "react";
import Card from "@mui/material/Card";
import SoftBox from "components/SoftBox";
import StepSelectionDialogButton from "layouts/Flow Designer/components/StepSelectionDialog";
import CustomNodeHandle from "layouts/Flow Designer/components/CustomNodes/components/CustomNodeHandle";

function PlaceholderNode({ data }) {
  const styles = { style: { border: `1px dashed #48BB78`, order: 1 } };

  return (
    <StepSelectionDialogButton source={data.source} target={data.target}>
      <SoftBox className="custom-node-wrapper" style={{ position: "relative", display: "flex" }}>
        <Card {...styles} className="custom-node-card placeholder-node">
          <SoftBox
            style={{
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          ></SoftBox>
        </Card>
        <CustomNodeHandle isTarget />
        <CustomNodeHandle />
      </SoftBox>
    </StepSelectionDialogButton>
  );
}
export default memo(PlaceholderNode);
